import { render, staticRenderFns } from "./issueRegister.vue?vue&type=template&id=77081814&scoped=true"
import script from "./issueRegister.vue?vue&type=script&lang=js"
export * from "./issueRegister.vue?vue&type=script&lang=js"
import style0 from "./issueRegister.vue?vue&type=style&index=0&id=77081814&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77081814",
  null
  
)

export default component.exports